import { percentage } from './percentage'
import { date } from './date'
import { roundDownNumberOfCompanies } from './number'

export const Formatting = { percentage, date, roundDownNumberOfCompanies }
export * from './number'
export * from './countryCode'
